<template>
    <div class="btn-group">
        <u-button-group-item
                v-for="(opt, index) in options"
                :key="index"
                v-model="model"
                :val="opt.value"
                :label="opt.label"
                @focus="__onFocus"
                @blur="__onBlur"
                @change="__onChange"
                class="btn btn-sm"
                :class="bindClass(opt.class)">
        </u-button-group-item>
    </div>
</template>

<script>
  export default {
    name: 'u-button-group',
    props: {
      value: {
        required: true
      },
      multiSelect: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        validator (opts) {
          return opts.every(opt => 'value' in opt && 'label' in opt)
        }
      },
      disabled: Boolean
    },
    methods: {
      __onChange () {
        this.$nextTick(() => {
          this.$emit('change', this.model)
        })
      },
      __onFocus () {
        this.$emit('focus')
      },
      __onBlur () {
        this.$emit('blur')
      },
      bindClass (c) {
        return c
      }
    },
    created () {
      const isArray = Array.isArray(this.value)
      if (!isArray && this.multiSelect) {
        console.error('u-button-group with multi-select option requires that v-model be an array')
      }
    },
    computed: {
      model: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>

<!--<style lang="stylus"></style>-->



// WEBPACK FOOTER //
// UButtonGroup.vue?91137ce6